<div class="modal-container">
  <div class="modal-header">
    <h3 class="modal-title">Delete</h3>

    <button mat-icon-button (click)="cancel()" class="close-btn">
      <mat-icon>close</mat-icon>
    </button>

  </div>

  <div class="modal-actions">
    <button mat-button type="button" (click)="cancel()">Cancel</button>
    <button mat-raised-button color="primary" (click)="delete()">Submit for approval</button>
  </div>
</div>
